import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
  standalone: false,
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent {
  public configurationService = inject(ConfigurationService);
  private route = inject(ActivatedRoute);

  public errorReason: string | null = null;
  public groupLink: string | null = null;
  public errorCode: string | null = null;

  constructor() {
    this.route.queryParams.subscribe(params => {
      this.errorReason = params['reason'] || null;
      this.groupLink = params['groupLink'] || null;
      this.errorCode = params['errorCode'] || null;
    });
  }
}
